import { jsx } from "react/jsx-runtime";
import { COMPONENT_NAME } from "./constants.js";
import { Link } from "../Link/index.js";
const BackToTopLink = ({ text }) => {
  return /* @__PURE__ */ jsx(Link, { href: "#top", "data-testid": COMPONENT_NAME, variant: "t5", children: text });
};
BackToTopLink.displayName = COMPONENT_NAME;
export {
  BackToTopLink
};
